<lib-login-page [content]="content" (authLogin)="login()"></lib-login-page>
